import Reflection from '../reflection.js';

/**
 * Create the action
 */

const { thunk, request, success, error } = Reflection.index((fetch) =>
  fetch.get('/reflections')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
